
//old
const vendormenu = [
  
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
    dashboard: true,
  },
  {
    icon:"cart",
    text:"Orders / Services",
    link:"/orders",
    dashboard:false,
  },
  {
    icon:"card-view",
    text:"Main Packages",
    link:"/products",
    dashboard: true,   
  },  
  {
    icon:"comments",
    text:"Notifications",
    link:"/notifications",
    dashboard: true,   
  },  
  {
    icon:"building",
    text:"Update Zone",
    link:"/update-zone",
    dashboard: true,   
  },  
  
  
  
  
  
  
  
 
  // {
  //   icon:"card-view",
  //   text:"Test Page",
  //   link:"/test-page",
  //   dashboard:false,
  // },
  
 
  {
    icon: "grid-alt",
    text: "Applications",
    active: false,
    subMenu: [ ],
  },
 
  
  
];
export default vendormenu;
